// One-shot handoff of a pre-filled composer draft to a brand-new conversation:
// a quick action stashes its seed prompt keyed by conversation id, the new
// conversation consumes it once on mount to pre-fill — not send — the composer.
// Sibling to pendingFirstMessage (which sends); keying by id (not router-history
// state) makes leaks into another conversation or back-nav replays impossible.

const queue = new Map<string, string>();

export function stashPendingComposerDraft(conversationId: string, draft: string): void {
  queue.set(conversationId, draft);
}

// Read and remove this conversation's queued composer draft, if any.
export function takePendingComposerDraft(conversationId: string): string | undefined {
  const draft = queue.get(conversationId);
  queue.delete(conversationId);
  return draft;
}
